<!-- 授权说明 -->
<template>
  <div>
    <div class="block-title">授权用途范围对比</div>
    <div class="table">
      <!-- 用途限制-图片 -->
      <div class="row-table">
        <div class="row-main" style="font-size:18px; line-height: 40px;">用途限制-图片</div>
        <div class="row-right" style="font-size:18px; text-align: center; line-height: 40px;">标准授权</div>
        <div class="row-right" style="font-size:18px; text-align: center; line-height: 40px;">扩展授权</div>
        <div class="row-right" style="font-size:18px; text-align: center; line-height: 40px;">会员授权</div>
      </div>
      <!-- 适用范围 -->
      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;"><span style="color:#999">适用范围：</span>媒体广告</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>
      <!-- 数字用途 -->
      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;"><span
            style="color:#999">数字用途：</span>自媒体文章配图（例如新浪微博、网易、头条号、微信公众号等）</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;">
          &emsp;&emsp;&emsp;&emsp;&emsp;自媒体短视频、自媒体直播配图（例如：快手、头条等）</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;">
          &emsp;&emsp;&emsp;&emsp;&emsp;电商平台商品详情页配图（例如淘宝、天猫、京东网、拼多多）</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;">&emsp;&emsp;&emsp;&emsp;&emsp;网站、客户端商业广告配图</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <!-- 线下印刷 -->
      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;"><span
            style="color:#999">线下印刷：</span>宣传页，手册、海报，易拉宝等线下印刷</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">限量100万份</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;">&emsp;&emsp;&emsp;&emsp;&emsp;报纸、杂志及图书等内文印刷</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">限量100万份</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;">&emsp;&emsp;&emsp;&emsp;&emsp;报纸、杂志及图书封面及封底印刷
        </div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">限量100万份</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <!-- 中外广告 -->
      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;"><span
            style="color:#999">中外广告：</span>楼宇、车身、灯箱、围挡、橱窗等户外广告及户外视频广告、公共表演、展会展览等</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">不支持</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <!-- 转售商品 -->
      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;"><span
            style="color:#999">转售商品：</span>在数字商品中使用，包括软件程序，设计模板，壁纸，主题皮肤课件等</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">不支持</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;">
          &emsp;&emsp;&emsp;&emsp;&emsp;在实物商品中使用，包括手机壳、贺卡、明信片、日历、杯子、T恤、包装、实物礼品等</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">不支持</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <!-- 影视制作 -->
      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;"><span
            style="color:#999">影视制作：</span>网络电视，网络视频，电影，电视节目等</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">不支持</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <!-- 铭感用途 -->
      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;"><span
            style="color:#999">敏感用途：</span>医疗、药物、烟草、美容整容、保健品类广告及宣传</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">不支持</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <!-- 商标logo -->
      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;"><span style="color:#999">商标LOGO：</span>商标、LOGO
        </div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">不支持</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">不支持</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <!-- 授权期限 -->
      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;"><span style="color:#999">授权期限：</span></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">下载后可永久使用</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">下载后可永久使用</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">下载后可永久使用</div>
      </div>、

      <!-- 用途限制-视频 -->
      <div class="row-table">
        <div class="row-main" style="font-size:18px; line-height: 40px;">用途限制-视频</div>
        <div class="row-right" style="font-size:18px; text-align: center; line-height: 40px;">标准授权</div>
        <div class="row-right" style="font-size:18px; text-align: center; line-height: 40px;">扩展授权</div>
        <div class="row-right" style="font-size:18px; text-align: center; line-height: 40px;">会员授权</div>
      </div>

      <!-- 数字用途 -->
      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;"><span
            style="color:#999">媒体出版：</span>出版媒体、编辑网站、博客、微博、微信公众号、自媒体号等非商业性使用</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>
      <!-- 在线广告 -->
      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;"><span
            style="color:#999">在线广告：</span>网络广告，社交网络、移动设备广告、移动应用程序（APP）、电脑软件（限于非售卖类软件）</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <!-- 现场演唱 -->
      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;"><span
            style="color:#999">现场演出：</span>出版媒体、编辑网站、博客、微博、微信公众号、自媒体号等非商业性使用</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <!-- 个人欣赏 -->
      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;"><span
            style="color:#999">个人欣赏：</span>学习、研究（不得进行转售、分销、提供他人复制、下载使用）</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <!-- 电影电视 -->
      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;"><span
            style="color:#999">电影电视：</span>电视、电影、微电影、网络视频、多媒体演示</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">不支持</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <!-- 中外广告 -->
      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;"><span
            style="color:#999">中外广告：</span>学习、研究（不得进行转售、分销、提供他人复制、下载使用）</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">不支持</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;"><i class="el-icon-check"
            style="color:#DC3B3B;font-size: 32px"></i></div>
      </div>

      <!-- 授权期限 -->
      <div class="row-table">
        <div class="row-main" style="font-size:14px; line-height: 40px;"><span style="color:#999">授权期限：</span></div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">授权后可永久使用</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">授权后可永久使用</div>
        <div class="row-right" style="font-size:14px; text-align: center; line-height: 40px;">授权后可永久使用</div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'authorizationDetail',
  created() { },
  data() {
    return {}
  },
  methods: {},
  computed: {},
  watch: {},
  filters: {},
  components: {}
}
</script>

<style scoped lang='scss'>
.block-title {
  text-align: center;
  font-size: 30px;
  margin-top: 10px;
  margin-bottom: 40px;
}

// 授权对话框表格
.row-table {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:nth-child(2n) {
    background-color: #f7f7f7;
  }
}

.row-main {
  width: 780px;
  height: 40px;
  padding-left: 15px;
}

.row-right {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 130px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/authorizationDetail.vue